import apiClient from './client';
import { ImportSession, UnvalidatedBook, BookValidation, GoogleBookMatch, DuplicateInfo } from '../types';

export const importsApi = {
  // Get current import session
  getCurrentSession: async (): Promise<ImportSession | null> => {
    try {
      const response = await apiClient.get<ImportSession>('/import/session/current');
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  // Upload Goodreads CSV
  uploadGoodreadsCSV: async (file: File): Promise<ImportSession> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post<ImportSession>('/import/goodreads/upload', formData);
    return response.data;
  },

  // Get unvalidated books for a session
  getUnvalidatedBooks: async (sessionId: number): Promise<UnvalidatedBook[]> => {
    const response = await apiClient.get<UnvalidatedBook[]>(`/import/session/${sessionId}/unvalidated`);
    return response.data;
  },

  // Validate a single book
  validateBook: async (bookId: number, validation: BookValidation): Promise<UnvalidatedBook> => {
    const response = await apiClient.post<UnvalidatedBook>(`/import/validate/${bookId}`, validation);
    return response.data;
  },

  // Search for books within import modal
  searchBooks: async (query: string, importSessionId?: number): Promise<GoogleBookMatch[]> => {
    const params: Record<string, string | number> = { query };
    if (importSessionId) {
      params.import_session_id = importSessionId;
    }

    const response = await apiClient.post<GoogleBookMatch[]>('/import/search', null, {
      params
    });
    return response.data;
  },

  // Complete import session
  completeSession: async (sessionId: number): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>(`/import/session/${sessionId}/complete`);
    return response.data;
  },

  // Cancel import session
  cancelSession: async (sessionId: number): Promise<{ message: string }> => {
    const response = await apiClient.delete<{ message: string }>(`/import/session/${sessionId}`);
    return response.data;
  },

  // Check if book is duplicate
  checkDuplicate: async (googleBooksId: string): Promise<DuplicateInfo> => {
    const response = await apiClient.post<DuplicateInfo>(`/import/check-duplicate/${googleBooksId}`);
    return response.data;
  },

  // Skip book during validation
  skipBook: async (sessionId: number, bookId: number): Promise<void> => {
    await apiClient.post(`/import/session/${sessionId}/skip/${bookId}`);
  },
};
